import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Grid, IconButton, CircularProgress } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import List from "components/list/List";
import { IHeaders } from "components/list/ListHeaders/ListHeaders.interface";
import ViewHeader from "components/rootComponents/Standards/ViewHeader/ViewHeader";
import useLists from "utils/customHooks/useLists";
import { IEgresados } from "views/Egresados/Egresados.interface";

const EstudiantesUGListado = (props: IEgresados) => {
  const title = "Estudiantes";

  console.log("Filtros disponibles en props.filters:", props.filters);


  const {
    users,
    columns,
    isLoadingList,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    sortColumn,
    setSortColumn,
    search,
    setSearch,
    sortDirection,
    setSortDirection,
    totalPages,
  } = useLists("/v1.1/estudiantesUG/listado", props.filters);

  // 📌 Generar headers excluyendo "cedula"
  const headerCells = columns
  .filter((column: string) => column.toLowerCase() !== "cedula")
  .map((column: string) => {
    const id = column.toLowerCase().replace(/ /g, "_");
    return {
      id,
      numeric: false,
      label: column,
      // Solo marcar "nombre", "edad" y "carrera" como ordenables
      sortable: ["nombre", "edad", "carrera"].includes(id)
    };
  });



  // 📌 Filtrar lista de estudiantes sin cédula
  const studentsList = users.map((student: any) => {
    //const { cedula, ...rest } = student;
    const { cedula, Cedula, ...rest } = student; // ✅ Elimina ambas variantes
    return rest;
  });

  // 📌 Función para descargar el CSV
  const handleDownloadCsv = async () => {
    try {
      const queryParams = new URLSearchParams({
        filters: JSON.stringify(props.filters), // ✅ Pasamos filtros al backend
      });


      //const API_URL = `http://localhost:4000/v1.1/estudiantesUG/descargar_csv?${queryParams}`;
      const API_URL = `https://ec2-18-231-158-5.sa-east-1.compute.amazonaws.com:4000/v1.1/estudiantesUG/descargar_csv?${queryParams}`;


      const response = await fetch(API_URL, { method: "GET" });

      if (!response.ok) {
        throw new Error(`HTTP Error ${response.status}: ${response.statusText}`);
      }

      // 📌 Validar que la respuesta es CSV
      const contentType = response.headers.get("content-type");
      if (!contentType || !contentType.includes("text/csv")) {
        throw new Error("❌ El backend no devolvió un archivo CSV.");
      }

      // 📌 Convertir la respuesta en un archivo Blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      // 📌 Crear y disparar la descarga del archivo
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `estudiantes_${new Date().toISOString().split("T")[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("❌ Error al descargar el CSV:", error);
      alert(`Error al descargar el CSV: ${error instanceof Error ? error.message : "Error desconocido"}`);
    }
  };



  return (
    <Grid container spacing={2} style={{ alignItems: "center", marginTop: "0px" }}>
      <Grid item xs={12} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <ViewHeader title={title} />
        <IconButton onClick={handleDownloadCsv}>
          <DownloadIcon sx={{ color: "#007BFF" }} />
        </IconButton>
      </Grid>

      <Grid item xs={12}>
  {isLoadingList ? (
    <Grid container justifyContent="center">
      <CircularProgress />
    </Grid>
  ) : studentsList.length === 0 ? (
<p style={{ color: "#5c5662", fontSize: "16px" }}>
  No hay datos para los filtros seleccionados.
</p>

  ) : (
    <List
      search={search}
      headers={headerCells}
      rows={studentsList}
      isLoading={isLoadingList}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}
      totalPages={totalPages}
      sortColumn={sortColumn}
      setSortColumn={setSortColumn}
      sortDirection={sortDirection}
      setSortDirection={setSortDirection}
    />
  )}
</Grid>

    </Grid>
  );
};

const mapStateToProps = (state: any) => {
  return { filters: state.filters };
};

export default connect(mapStateToProps)(EstudiantesUGListado);
